import { cls } from '@/utils/cls';

export type CapacityTestStatusIconProps = {
  statusColor: 'green' | 'yellow' | 'red' | 'zinc';
};

export function CapacityTestStatusIcon({
  statusColor,
}: CapacityTestStatusIconProps) {
  return (
    <div
      className={cls(
        'size-3 rounded-full',
        statusColorMap[statusColor] || 'bg-zinc-500',
      )}
    ></div>
  );
}

const statusColorMap = {
  green: 'bg-green-500',
  yellow: 'bg-yellow-500',
  red: 'bg-red-500',
  zinc: 'bg-zinc-500',
};
